import { Link } from 'react-router-dom';

const footerNav = [
  {
    title: '浏览漫画',
    links: [
      { label: '全部漫画', path: '/category/all' },
      { label: '热门推荐', path: '/category/all' },
      { label: '最新更新', path: '/category/all' },
      { label: '已完结', path: '/category/all' },
    ],
  },
  {
    title: '热门分类',
    links: [
      { label: '恋爱韩漫', path: '/category/romance' },
      { label: '奇幻韩漫', path: '/category/fantasy' },
      { label: '动作韩漫', path: '/category/action' },
      { label: '悬疑韩漫', path: '/category/thriller' },
    ],
  },
  {
    title: '关于本站',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '用户口碑', path: '/about' },
      { label: '联系我们', path: '/about' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-300">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-book-open-line text-background-50 text-lg"></i>
              </div>
              <span className="text-lg font-bold text-foreground-50 font-heading">
                虚空韩漫网
              </span>
            </Link>
            <p className="text-sm leading-relaxed text-foreground-400">
              免费的韩漫在线阅读平台，提供高清下拉式韩漫全集。
              <br />
              所有内容正版合规，每日更新。
            </p>
          </div>

          {footerNav.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-100 mb-3">{group.title}</h4>
              <ul className="flex flex-col gap-2">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-400 hover:text-foreground-100 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 虚空韩漫网. 本站所有漫画内容均为正版授权，仅供在线阅读。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}